import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' // 进度条样式
import { getToken } from '@/utils/auth' // 从cookie获取token
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // 进程配置

// 不需要登录的路由
const noLoginArr = ['Login', 'TankDemandInfo', 'Reg', 'Home', 'EnterpriseShow', 'exhibition', 'list', 'detailsSee', 'PetroTransport', 'SourceNews', 'TransportNews', 'Cloud', 'TankSupplyInfo', 'TtorageSupplyInfo', 'TtorageDemandInfo', 'TtorageDemandInfo', 'Monitor', 'OrderInfo', 'WaybillRoute'] // 需要登录的路由name
// 需要认证的页面
const needAuth = ['Sponsor', 'BusinessEnterprise', 'contacts', 'PublishGoods', 'PublishTransport', 'PublishSupply', 'PublishDemand', 'Staff', 'CompanyInfo', 'OrderList']

router.beforeEach(async(to, from, next) => {
  // 开始进度条
  NProgress.start()
  // 设置页面标题
  document.title = getPageTitle(to.meta.title)

  // 确定用户是否已登录
  const hasToken = getToken()

  if (hasToken) {
    if (to.name === 'Login' || to.name === 'Reg') {
      // 如果已登录，请重定向到主页
      next({ path: '/' })
      NProgress.done()
    } else {
      // 确定用户是否通过getinfo获取了权限角色
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        // const authStatus = store.getters.roles[0].split('-')[1]
        // 判断跳转页面是否需要认证
        // && authStatus == '0'
        if (needAuth.indexOf(to.name) != -1 && store.getters.authStatus != '2') {
          // console.log('跳转')
          if (from.name == 'QualificationsAuthen') {
            NProgress.done()
            next(false)
          } else {
            next({ name: 'QualificationsAuthen' })
          }
        } else {
          next()
        }
      } else {
        try {
          // 获取用户信息
          await store.dispatch('user/getInfo')
          next()
        } catch (error) {
          // 删除令牌并转到登录页重新登录
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/log/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* 没有token*/
    if (noLoginArr.indexOf(to.name) !== -1) {
      // 不需要登录的页面
      next()
    } else {
      // 需要登录的页面
      next(`/log/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // 完成进度条
  NProgress.done()
})
